<template>
  <div class="nwx-app-products-select"
       :class="{error: error}">
    <div class="product-section"
         v-for="(section) in sections"
         :key="section.title"
    >
      <div class="section-title">{{section.title}}</div>

      <div class="products-list-wrapper">
        <div class="product-list-item"
             v-for="(productOption, index) in section.separateProducts"
             :key="index"
        >
          <label :class="{'nwx-checkbox': true, 'error': error}">
            <input v-if="productOption.groupOnly"
                   type="checkbox"
                   :name="productOption.prodCode"
                   :id="productOption.prodCode"
                   :checked="isGroupSelected(productOption)"
                   @change="toggleRelatedProducts(productOption, $event.target.checked)"
            >
            <input v-else
                   type="checkbox"
                   :value="productOption.prodCode"
                   :name="productOption.prodCode"
                   :id="productOption.prodCode"
                   v-model="localSelected"
                   @change="toggleRelatedProducts(productOption, $event.target.checked)"
            >
            <span class="checkmark"></span>
            <span class="label-text">
              <img :src="productOption.iconSrc" :alt="productOption.prodName">
              <strong class="item-product-title">{{productOption.prodName}}</strong>
            </span>
          </label>

          <div class="related-products" v-if="productOption.relatedProducts">
            {{productOption.relatedProducts.map((p) => p.name).join(', ')}}
          </div>

          <div class="item-data">
            <p class="item-product-text">{{productOption.descripText}}</p>
            <div class="item-product-link">
              <a target="_blank" :href="'https://www.netwrix.com/'+productOption.prodLink">Learn More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'NwxAppProductsSelect',
    props: {
      items: {
        type: Object,
      },
      selected: {
        type: [String, Array],
        default: undefined,
      },
      error: Boolean,
    },
    model: {
      prop: 'selected',
      event: 'appselect:changed',
    },
    data() {
      return {
        sections: [],
        localSelected: [],
      };
    },
    watch: {
      selected(selected) {
        // eslint-disable-next-line vue/no-mutating-props
        this.selected = selected;
      },
      localSelected(selected) {
        this.$emit('appselect:changed', selected);
      },
    },
    methods: {
      isGroupSelected(productOption) {
        return productOption.relatedProducts.every((p) => this.localSelected.includes(p.code));
      },
      toggleRelatedProducts(productOption, isSelected) {
        if (!productOption.relatedProducts) return;

        const relatedCodes = productOption.relatedProducts.map((p) => p.code);

        if (isSelected) {
          relatedCodes.forEach((code) => {
            if (!this.localSelected.includes(code)) {
              this.localSelected.push(code);
            }
          });
        } else {
          this.localSelected = this.localSelected.filter((code) => !relatedCodes.includes(code));
        }
      },
    },
    created() {
      const { coreProducts, psgProducts } = this.items;

      this.sections = [coreProducts, psgProducts].map((section) => ({
        title: section.title,
        separateProducts: section.separateProducts || [],
      }));
    },
  };
</script>
<style lang="less" scoped>
@import "../assets/variables";

.nwx-app-products-select{
  width: 100%;
  border: 1px solid #000000;
  &.error{
    border-color: @mainRed;
  }

  .section-title{
    font-family: Hubot Sans,HubotSans-fallback,Courier New,monospace;
    font-size: 1.135rem;
    font-weight: 500;
    line-height: 1.2;
    margin: 30px 30px 0 30px;
  }

  .products-list-wrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    row-gap: 50px;
    margin: 43px 30px 50px 30px;

    @media (min-width: 1600px) {
      justify-content: flex-start;
      row-gap: 65px;
      column-gap: 50px;
    }

    .product-list-item {
      display: flex;
      flex-direction: column;
      gap: 15px;

      .label-text {

        img {
          display: none;
          width: 20px;
          height: 20px;
          margin: -2px 10px 0 8px;
        }

        strong {
          font-family: Hubot Sans,HubotSans-fallback,Courier New,monospace;
          font-size: 1.135rem;
          font-weight: 500;
          line-height: 1.2;
          margin: 0;
        }
      }

      .related-products{
        padding-left: 33px;
        color: @colorH;
        font-size: 0.8rem;
        font-weight: 400;
        line-height: 1.3;
        margin-top: -10px;
      }

      .item-data{
        width: 332px;
        padding-left: 33px;

        .item-product-text{
          color: @colorH;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.4;
          margin-bottom: 16px;
        }
        .item-product-link{
          a{
            color: @vigilantBlue;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.4;
            text-decoration: underline !important;

            &:hover {
              text-decoration: none !important;
            }
          }
        }
      }
    }
  }

  .nwx-checkbox {
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin: 0;
    padding: 0;

    .label-text {
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.9;
      padding-left: 33px;
      vertical-align: baseline;
    }

    input {
      cursor: pointer;
      position: absolute;
      opacity: 0;
      height: 0;
      width: 0;

      &:focus ~ .checkmark {
        border-color: @vigilantBlue !important;
      }

      &:checked ~ .checkmark {
        background: @vigilantBlue !important;
        border-color: @vigilantBlue !important;
      }
    }

    .checkmark {
      position: absolute;
      top: 5px;
      left: 0;
      height: 16px;
      width: 16px;
      border: 1px solid @vigilantBlue;
      background: @accessWhite;
      transition: background 0.2s, border 0.2s;
    }

    &:not(.error):not(.disabled):hover {
      .checkmark {
        background: #5851db33;
      }
    }

    &.huge {
      .label-text {
        font-size: 16px;
        padding-left: 50px;
      }

      .checkmark {
        top: -3px;
        height: 36px;
        width: 36px;

        &:after {
          background-image:
            url('//img.netwrix.com/elements/partnerPortal/pipeline/checkmark_huge.svg');
        }
      }
    }

    &.error {
      .label-text {
        color: @mainRed;
      }

      .checkmark {
        border-color: @mainRed;
      }
    }

    &.disabled {
      cursor: default;

      .label-text {
        color: fade(@mainGray, 80%);
      }

      .checkmark {
        background: fade(@bodyWhite, 60%);
        border-color: fade(@mainGray, 20%);
      }

      input {
        &:checked ~ .checkmark {
          background: fade(@vigilantBlue, 60%);
          border-color: transparent !important;
        }
      }
    }
  }
}

</style>
